// extracted by mini-css-extract-plugin
export default {"quotations":"Quotations_quotations__pcsis"};